import { TRiskLevel } from '@interfaces/riskLevels';

import useRiskLevels from './useRiskLevels';

const useRiskLevelById = (riskLevelId?: TRiskLevel | null) => {
  const riskLevels = useRiskLevels();
  return riskLevels.find(riskLevel => riskLevel.riskLevelId === riskLevelId);
};

export default useRiskLevelById;
